import React, {PureComponent} from 'react';
import {
  Col,
  Row,
  Grid,
  Image,
  Nav,
  NavItem,
} from 'react-bootstrap';
import StackGrid from 'react-stack-grid';
import './GalleryPage.css';

class GalleryPage extends PureComponent {

  constructor() {
    super();

    this.state = {
      selectedPictureSet: 'carmen',
      pictureSetList: ['santafe-2013', 'magic-flute', 'carmen','forte','performance','operafest'],
      pictureSets: {
        'operafest': {
          name: 'Operafest',
          code: 'operafest',
          pictures: [
            {
              file: 'operafest-1.jpg',
              width: 480,
              height: 640,
            },
          ],
        },
        'santafe-2013': {
          name: 'Santa Fe Apprentice Scenes',
          code: 'santafe-2013',
          pictures: [
            {
              file: 'santafe-2013-1.jpg',
            },
            {
              file: 'santafe-2013-2.jpg',
            },
            {
              file: 'santafe-2013-3.jpg',
            },
            {
              file: 'santafe-2013-4.jpg',
            },
            {
              file: 'santafe-2013-5.jpg',
            },
            {
              file: 'santafe-2013-6.jpg',
            },
            {
              file: 'santafe-2013-7.jpg',
            },
            {
              file: 'santafe-2013-8.jpg',
            },
            {
              file: 'santafe-2013-9.jpg',
            },
            {
              file: 'santafe-2013-10.jpg',
            },
            {
              file: 'santafe-2013-11.jpg',
            },
            {
              file: 'santafe-2013-12.jpg',
            },
            {
              file: 'santafe-2013-13.jpg',
            },
            {
              file: 'santafe-2013-14.jpg',
            },
          ]
        },
        'carmen': {
          name: 'Carmen',
          code: 'carmen',
          pictures: [
            {
              file: 'carmen-1.jpg',
            },
            {
              file: 'carmen-2.jpg',
            },
            {
              file: 'carmen-3.jpg',
            },
            {
              file: 'carmen-4.jpg',
            },
            {
              file: 'carmen-6.jpg',
            },
            {
              file: 'carmen-7.jpg',
            },
            {
              file: 'carmen-8.jpg',
            },
            {
              file: 'carmen-9.jpg',
            },
            {
              file: 'carmen-10.jpg',
            },
            {
              file: 'carmen-11.jpg',
            },
            {
              file: 'carmen-12.jpg',
            },
            {
              file: 'carmen-13.jpg',
            },
            {
              file: 'carmen-14.jpg',
            },
            {
              file: 'carmen-15.jpg',
            },
          ]
        },
        'magic-flute': {
          name: 'Magic Flute',
          code: 'magic-flute',
          pictures: [
            {
              file: 'magic-flute-1.jpg',
            },
            {
              file: 'magic-flute-2.jpg',
            },
            {
              file: 'magic-flute-3.jpg',
            },
            {
              file: 'magic-flute-4.jpg',
            },
          ]
        },
        'forte': {
          name: 'Forte Chicago',
          code: 'forte',
          pictures: [
            {
              file: 'forte-1.jpg',
            },
            {
              file: 'forte-2.jpg',
            },
            {
              file: 'forte-3.jpg',
            },
            {
              file: 'forte-4.jpg',
            },
            {
              file: 'forte-5.jpg',
            },
            {
              file: 'forte-6.jpg',
            },
            {
              file: 'forte-7.jpg',
            },
            {
              file: 'forte-8.jpg',
            },
            {
              file: 'forte-9.jpg',
            },
            {
              file: 'forte-10.jpg',
            },
          ],
        },
        'performance': {
          name: 'Performance',
          code: 'performance',
          pictures: [
            {
              file: 'performance-1.jpg',
            },
            {
              file: 'performance-2.jpg',
            },
            {
              file: 'performance-3.jpg',
            },
          ],
        },
      }
    };
  }

  shuffle(a) {
    for (let i = a.length; i; i--) {
      let j = Math.floor(Math.random() * i);
      [a[i - 1], a[j]] = [a[j], a[i - 1]];
    }
    return a;
  }

  render() {
    const sets = [];
    this.state.pictureSetList.forEach((set) => {
      sets.push(
        <NavItem
          key={set}
          onClick={() => {
            this.setState({ selectedPictureSet: set} );
          }}
          selected={this.state.selectedPictureSet === set}
        >
          {this.state.pictureSets[set].name}
        </NavItem>,
      );
    });

    const pictures = [];
    this.state.pictureSets[this.state.selectedPictureSet].pictures.forEach((picture) => {
      pictures.push(
        <Image
          key={picture.file}
          src={`/gallery/${picture.file}`}
          width={picture.width}
          height={picture.height}
          alt={`${picture.filename}`}
          thumbnail
        />,
      );
    });


    return (
      <div>
        <Grid>
          <Row>
            <Col sm={12} smOffset={0} className="GalleryPage-Nav">
              <Nav bsStyle="pills">
                {sets}
              </Nav>
            </Col>
          </Row>
          <hr/>
            { this.state.selectedPictureSet === 'operafest' ?
              <Row>
                <Col md={6} sm={6} xs={12}>
                  <StackGrid
                    columnWidth="100%"
                    monitorImagesLoaded
                    gridRef={grid => this.grid = grid}
                  >
                    {this.shuffle(pictures)}
                  </StackGrid>
                </Col>
                <Col md={6} sm={6} xs={12}>



                  <event>
                    <piece>Impresario</piece>
                    <composer>Wolfgang Amadeus Mozart</composer>
                    <location>Chicago College of Performing Arts</location>
                    <year>2016</year>
                  </event>
                  <event>
                    <piece>La Canterina</piece>
                    <composer>Franz Joseph Haydn</composer>
                    <location>Chicago College of Performing Arts</location>
                    <year>2016</year>
                  </event>
                  <event>
                    <piece>Bluebeard’s Waiting Room</piece>
                    <composer>Milton Granger</composer>
                    <location>Chicago College of Performing Arts</location>
                    <year>2015</year>
                  </event>
                  <event>
                    <piece>Riders to the Sea</piece>
                    <composer>Ralph Vaughan Williams</composer>
                    <location>Chicago College of Performing Arts</location>
                    <year>2014</year>
                  </event>
                  <event>
                    <piece>The Beautiful Bridegroom</piece>
                    <composer>Dan Shore</composer>
                    <location>Chicago College of Performing Arts</location>
                    <year>2014</year>
                  </event>
                  <event>
                    <piece>Roman Fever</piece>
                    <composer>Robert Ward</composer>
                    <location>Chicago College of Performing Arts</location>
                    <year>2014</year>
                  </event>
                  <event>
                    <piece>King Harald’s Saga</piece>
                    <composer>Judith Weir</composer>
                    <location>Chicago College of Performing Arts</location>
                    <year>2014</year>
                  </event>
                  <event>
                    <piece>Doctor Miracle</piece>
                    <composer>Georges Bizet</composer>
                    <location>Chicago College of Performing Arts</location>
                    <year>2013</year>
                  </event>
                  <event>
                    <piece>Captain Lovelock</piece>
                    <composer>John Duke</composer>
                    <location>Chicago College of Performing Arts</location>
                    <year>2013</year>
                  </event>
                  <event>
                    <piece>Suor Angelica</piece>
                    <composer>Giacomo Puccini</composer>
                    <location>Chicago College of Performing Arts</location>
                    <year>2012</year>
                  </event>
                  <event>
                    <piece>The Princess and The Pea</piece>
                    <composer>Ernst Toch</composer>
                    <location>Chicago College of Performing Arts</location>
                    <year>2011</year>
                  </event>
                  <event>
                    <piece>Cendrillon</piece>
                    <composer>Pauline Viardot</composer>
                    <location>Chicago College of Performing Arts</location>
                    <year>2011</year>
                  </event>
                  <event>
                    <piece>Again</piece>
                    <composer>Jake Heggie</composer>
                    <location>Chicago College of Performing Arts</location>
                    <year>2011</year>
                  </event>
                  <event>
                    <piece>Butterfly&apos;s Wedding</piece>
                    <composer>Giacomo Puccini</composer>
                    <location>Chicago College of Performing Arts</location>
                    <year>2011</year>
                  </event>
                </Col>
              </Row>
            :
              <Row>
                <Col md={12} xsHidden smHidden>
                  <StackGrid
                    columnWidth="33%"
                    monitorImagesLoaded
                    gridRef={grid => this.grid = grid}
                  >
                    {this.shuffle(pictures)}
                  </StackGrid>
                </Col>
                <Col sm={12} xsHidden mdHidden lgHidden>
                  <StackGrid
                    columnWidth="50%"
                    monitorImagesLoaded
                    gridRef={grid => this.grid = grid}
                  >
                    {this.shuffle(pictures)}
                  </StackGrid>
                </Col>
                <Col xs={12} smHidden mdHidden lgHidden>
                  <StackGrid
                    columnWidth="100%"
                    monitorImagesLoaded
                    gridRef={grid => this.grid = grid}
                  >
                    {this.shuffle(pictures)}
                  </StackGrid>
                </Col>
              </Row>
            }
        </Grid>
      </div>
    );
  }
}

export default GalleryPage;



// WEBPACK FOOTER //
// ./src/containers/GalleryPage.jsx